import { AubadeComponent } from "js/front/bootstrap";
import { gsap } from 'gsap';
import { Sprite } from 'js/front/tools/Sprite';

export class SceneLoader extends AubadeComponent {
	constructor(e, b) {
		super(e, b);

		this.copy 		= this.element.querySelector('.copy');
		this.texts 		= Array.from(this.copy.querySelectorAll('span'));
		this.loading 	= this.element.querySelector('.loading');

		this.sprite = new Sprite(this.element.querySelector('img'));
		this.sprite.startIndex = 0;
		this.sprite.currentIndex = 0;
		this.sprite.loop = true;
	}

	async init(){
		await this.sprite.load();
	}

	showTexts(){
		const t = gsap.timeline({repeat:-1});

		this.texts.forEach((text, i) => {
			t.set(text, {display:'block'}, i*5);
			t.fromTo(text, {opacity:0}, {opacity:1, ease:'none', duration:0.5}, i*5);
			t.to(text, {opacity:0, ease:'none', duration:0.5}, (i+1)*5 -1);
			t.set(text, {display:'none'}, (i+1)*5);
		});

		this.showTextsTm = t;

		return t.play();
	}

	show(){
		this.sprite.play();
		const t = gsap.timeline();

		this.showTexts();

		return t;
	}

	hide(){
		const t = gsap.timeline();
		t.to(this.element, {opacity: 0, duration: 0.5}, 0);

		t.add(() => {
			this.showTextsTm.kill();
			this.sprite.reset();
			this.remove();
		});
		return t;
	}

	remove = () => {
		if(this.element.parentElement)
			this.element.parentElement.removeChild(this.element);
	}
}
